<template>
    <div class="google-stars">
        <div class="google-stars__rating">
            {{ stars }}
        </div>

        <div class="google-stars__stars">
            <div
                v-for="i in 5"
                :key="i"
                class="google-stars__star"
            >
                <!-- Show full star -->
                <svg
                    v-if="i <= stars"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 19 18"
                >
                    <polygon
                        fill="#ffaa3f"
                        points="9.5,0 12.08,6.42 19,6.88 13.67,11.3 15.37,18 9.5,14.32 3.63,18 5.33,11.3 0,6.88 6.92,6.42"
                    />
                </svg>

                <!-- Show partially filled star -->
                <svg
                    v-else-if="Math.ceil(stars) === i && stars % 1 > 0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 19 18"
                >
                    <polygon
                        fill="#d2d2d1"
                        points="9.5,0 12.08,6.42 19,6.88 13.67,11.3 15.37,18 9.5,14.32 3.63,18 5.33,11.3 0,6.88 6.92,6.42"
                    />
                    <polygon
                        :style="{'clip-path': getClipPath}"
                        fill="#ffaa3f"
                        points="9.5,0 12.08,6.42 19,6.88 13.67,11.3 15.37,18 9.5,14.32 3.63,18 5.33,11.3 0,6.88 6.92,6.42"
                    />
                </svg>

                <!-- Show empty star -->
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 19 18"
                >
                    <polygon
                        fill="#d2d2d1"
                        points="9.5,0 12.08,6.42 19,6.88 13.67,11.3 15.37,18 9.5,14.32 3.63,18 5.33,11.3 0,6.88 6.92,6.42"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stars: {
            type: Number,
            required: true,
        },
    },

    computed: {
        getClipPath() {
            const percentage = this.stars % 1 * 100 + '%';
            return `polygon(0 0, ${percentage} 0, ${percentage} 100%, 0 100%)`;
        },
    },
};
</script>

<style lang="scss">
@import "zoe-atom-google-stars";
</style>
